var chunkToChildrenMap = {
	"1056": [
		736
	],
	"1381": [
		736
	],
	"1887": [
		736
	],
	"2588": [
		736,
		8772
	],
	"3254": [
		4834,
		7009,
		7472,
		9603,
		2008,
		7320,
		1602,
		7013,
		1887
	],
	"3521": [
		9935,
		8451
	],
	"4525": [
		736,
		8772
	],
	"4581": [
		736,
		8772
	],
	"6444": [
		736
	],
	"7069": [
		9686
	],
	"7311": [
		736,
		8772
	],
	"7396": [
		736
	],
	"8354": [
		736,
		8772,
		6822
	],
	"8951": [
		7320,
		7013,
		6444
	],
	"9689": [
		736,
		5755
	],
	"9697": [
		736,
		8772
	],
	"9919": [
		1349
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));